import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(tools)/image-tools/bulk-resizer/BulkImageResizerClientWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Card"] */ "/vercel/path0/components/ui/Card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientToolShell"] */ "/vercel/path0/components/ui/ClientToolShell.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["QuizWidget"] */ "/vercel/path0/src/components/els/QuizWidget.tsx");
